import Swiper, { Autoplay, Navigation } from 'swiper';

(function ($) {

  if($('.swiper').length > 0) {
    let loop = ($('.swiper:first img').length >= 6) ? true : false ;
    const swiper = new Swiper('.swiper', {
      autoplay: {
        delay: 5000,
      },
      centeredSlides: true,
      direction: 'horizontal',
      loop: loop,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      modules: [Autoplay, Navigation],
      slidesPerView: "auto",
      //speed: 1,
    });
  }

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/carousel.js